import React      from 'react';
import CSSModules from 'react-css-modules';

import style        from './style.scss';
import navigator    from '../../services/navigator';
import TransparentButton from '../TransparentButton';
import MaterialIcon from './../MaterialIcon';

import LinesEllipsis from 'react-lines-ellipsis'

const Course = props => {
    const typeIconMap = {
        'classroom': 'icon--classroom',
        'online': 'icon--online',
        'conference': 'icon--conference',
        'webinar': 'icon--webinar'
    };

    return (
        <div onClick={props.onClick.bind(this, props.course)} className={`${style['course']} ${props.singleEventType && style['course--single-type']}`}>
            <div className={style['course-list-icon-box']}>
                <div className={style[typeIconMap[props.courseType]]} style={props.courseBackgroundStyle}></div>
            </div>
            <div className={style['course-list-name-box']}>
                <div className={style['course-list-name-box__text']}>
                    <div style={props.colorStyle}>{props.moduleName}</div>
                    <LinesEllipsis
                        text={props.courseName}
                        maxLine='3'
                        ellipsis='...'
                        trimRight
                        basedOn='words'
                    />
                </div>
            </div>
        </div>
    );
};

const CourseList = props => {

    return (
        <div>
            {props.module.courses
                .filter(c => {
                    // Allows us to show webinars under the "Classroom" heading
                    if (props.courseType === "classroom"){
                        return c.type === "classroom" || c.type === "webinar";
                    }
                    return c.type === props.courseType;
                })
                .map(course => {
                    return (
                        <Course
                            key={course.id}
                            course={course}
                            onClick={props.onClick.bind(this)}
                            courseBackgroundStyle={props.courseBackgroundStyle(props.module)}
                            courseName={course.name}
                            courseType={course.type}
                            moduleName={props.moduleName}
                            colorStyle={props.colorStyle}
                            singleEventType={props.singleEventType}
                        />
                    )
                }
            )}
        </div>
    )
};

const CourseHeading = props => {
    return (
        <div className={style['section-heading-container']}>
            <h2 className={style["section-heading"]}>{props.courseHeading}</h2>
        </div>
    );
};

class MarketingCourseList extends React.Component {

    _getCourseBackgroundStyle() {

        if (this.props.selectedModule) {
            return {backgroundColor: this.props.selectedModule.hex_colour};
        }

        return null;
    }

    _getCourseColorStyle() {

        if (this.props.selectedModule) {
            return {color: this.props.selectedModule.hex_colour};
        }

        return null;
    }

    _isCourseTypeAvailable(type) {
        const hasCoursesOfType = this.props.selectedModule.courses.filter(c => c.type === type).length > 0;

        if (this.props.showEventTypes) {
            return hasCoursesOfType && this.props.showEventTypes.includes(type)
        }

        return hasCoursesOfType;
    }

    _navigateToCourse(course) {
        navigator.push(`/courses/${course.id}/${course.slug}`);
    }

    render() {

        if (!this.props.selectedModule) return null;

        const { selectedModule } = this.props;

        return (
            <div id="course-list" className={style['container']}>

                <span onClick={this.props.onCloseClick} className={style['close-button']}>&times;</span>

                {(this._isCourseTypeAvailable('classroom') || this._isCourseTypeAvailable('webinar')) && (
                    <div className={`${style['course-list-container']} ${this.props.showEventTypes && style['course-list-container--single-type']}`}>
                        <CourseHeading
                            courseHeading={`Courses`}
                            moduleName={selectedModule.name}
                        />
                        <CourseList
                            courseType="classroom"
                            module={selectedModule}
                            onClick={this._navigateToCourse.bind(this)}
                            courseBackgroundStyle={this._getCourseBackgroundStyle.bind(this)}
                            moduleName={selectedModule.name}
                            colorStyle={this._getCourseColorStyle()}
                            singleEventType={!!this.props.showEventTypes}
                        />
                    </div>
                )}

                {this._isCourseTypeAvailable('online') && (
                    <div className={`${style['course-list-container']} ${this.props.showEventTypes && style['course-list-container--single-type']}`}>
                        <CourseHeading
                            courseHeading={`e-Learning`}
                            moduleName={selectedModule.name}
                        />
                        <CourseList
                            courseType="online"
                            module={selectedModule}
                            onClick={this._navigateToCourse.bind(this)}
                            courseBackgroundStyle={this._getCourseBackgroundStyle.bind(this)}
                            moduleName={selectedModule.name}
                            colorStyle={this._getCourseColorStyle()}
                            singleEventType={!!this.props.showEventTypes}
                        />
                    </div>
                )}

                {this._isCourseTypeAvailable('conference') && (
                    <div className={`${style['course-list-container']} ${this.props.showEventTypes && style['course-list-container--single-type']}`}>
                        <CourseHeading
                            courseHeading={`Conferences`}
                            moduleName={selectedModule.name}
                        />
                        <CourseList
                            courseType="conference"
                            module={selectedModule}
                            onClick={this._navigateToCourse.bind(this)}
                            courseBackgroundStyle={this._getCourseBackgroundStyle.bind(this)}
                            moduleName={selectedModule.name}
                            colorStyle={this._getCourseColorStyle()}
                            singleEventType={!!this.props.showEventTypes}
                        />
                    </div>
                )}

            </div>
        );
    }
}

export default CSSModules(MarketingCourseList, style);


// WEBPACK FOOTER //
// ./components/MarketingCourseList/index.js